import {useCallback} from 'react';
import axiosInstance from '../axiosInstance';

/**
 * Custom hook to post prompt to weddinglyAI Chatbot
 * @param {string} chatId - The ID of the chat to post to
 * @returns {Object} - Object containing post function and loading state
 */
const usePostChat = () => useCallback(({chatId, prompt}) => {
  const baseUrl = window.localStorage.getItem("BaseURL");
  const endpoint = `/services/projectmanagement/api/ai-bot/chat${chatId ? `?chatId=${chatId}` : ''}`;
  const fullUrl = baseUrl + endpoint;

  return new Promise((resolve, reject) => {
    axiosInstance
      .post(fullUrl, { prompt })
      .then((res) => resolve(res.data))
      .catch(reject);
  });
}, []);

export default usePostChat;
